import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RetornoSelecao } from '../../../shared/gridview/RetornoSelecao';
import { Estado } from '../../../shared/shared/estado.enum';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-seminovos',
  templateUrl: './seminovos.component.html',
  styleUrls: ['./seminovos.component.css']
})
export class SeminovosComponent implements OnInit {

  selecionado: object;
  state: Estado = Estado.view;
  filtros = {};

  parametrosFiltro: any;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.carregarFiltrosParametros();
    });
  }

  ngOnInit() {
    const marca: any = { 
     "marcas": [40, 31]
    }
  }
 
  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
    if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
    }
    this.selecionado = selecionado.registro;
  }

  definirFiltro() {
    $('#seminovos-filtro').modal();
  }

}
